









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import ClientNoteService from '@/services/crm/client-note.service';
import ClientNoteModel from '@/models/crm/client-note.model';

@Component({})
export default class CrmClientNotesCard extends Vue {
  @inject(InjectionIdEnum.CrmClientNoteService)
  private clientNoteService!: ClientNoteService;

  @Prop({ required: true })
  readonly clientId!: string;

  @Prop({ required: true })
  readonly clientType!: ClientTypeEnum;

  @Prop({ default: false })
  readonly disabled!: boolean;

  // O dashboard incrementa a cada mudança no modal para o card recarregar.
  @Prop({ default: 0 })
  readonly refreshKey!: number;

  note: ClientNoteModel | null = null;

  total = 0;

  loading = false;

  loadError = false;

  mounted(): void {
    this.reload();
  }

  @Watch('clientId')
  onClientChange(): void {
    this.reload();
  }

  @Watch('refreshKey')
  onRefreshKeyChange(): void {
    this.reload();
  }

  async reload(): Promise<void> {
    this.note = null;
    this.total = 0;
    this.loadError = false;
    if (!this.clientId) return;
    this.loading = true;
    try {
      const featured = await this.clientNoteService.featured(this.clientId, this.clientType);
      this.note = featured.note;
      this.total = featured.total || 0;
    } catch (e) {
      this.loadError = true;
    } finally {
      this.loading = false;
    }
  }
}
